import { Component, OnInit, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { G_ColoursViewModel } from 'src/app/viewmodels/g-settings/G_ColoursViewModel';
import { SaveColourRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-colors-form',
  templateUrl: './colors-form.component.html',
  styleUrls: ['./colors-form.component.scss']
})
export class ColorsFormComponent implements OnInit {
  @Input() public vm: SaveColourRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  private submitted = false;
  public IsDublicate: boolean = false;
  modalRef: BsModalRef;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
  ) { }

  ngOnInit() {
    if (this.vm === undefined) {
      this.vm = new SaveColourRequest();
    }
    if (this.modal_title === undefined) {
      this.modal_title = 'Color';
    }
  }

  saveOrUpdate() {
    this._jq.showSpinner(true);
    this._uow.gSettingService
      .SaveColourAsync(this.vm)
      .toPromise().then((res: any) => {
        console.log(res);
        this.submitted = true;
        this.bsmRef.hide();
        this.onSubmitted.emit(this.submitted);
        Swal.fire(
          'Created!',
          'Created/Updated! Successfully',
          'success'
        )
      })
      .catch((error) => {
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(this.submitted);
      });
  }

  checkColorsDublication(tagName){
    debugger
    this._jq.showSpinner(true);
    this._uow.colourService.checkDublication(tagName).toPromise().then((res : any)=>{
      if (res === true) {
        this.IsDublicate = false;
      }else{
        this.IsDublicate = true;
      }
      this._jq.showSpinner(false);
    }).catch((error) => {
      console.log(`Promise rejected with ${JSON.stringify(error)}`);
      this.onSubmitted.emit(this.submitted);
      this._jq.showSpinner(false);
    });
  }

  openTagTypeModel(template: TemplateRef<any>) {
    this.openModal(template);
  }

  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._modalService.show(template);
    }
  }

  onColorSubmitted(e) {
    if (e == true) {
      this.modalRef.hide();
      this.ngOnInit();
    }
  }
  closeModal() {
    this.bsmRef.hide();
    this.onSubmitted.emit(true); // Emit event to refresh list
  }
}
